const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/dashboards/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import i18n from '@/common/translations/i18n';
import { ensureNamespaceLoaded } from '@/common/translations/i18nloader';
export const Route = createFileRoute('/(app)/org/$org/dashboards/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  beforeLoad: async () => {
    await ensureNamespaceLoaded('aiDashboards');
  },
  staticData: {
    topNav: {
      title: i18n.t($ => $.dashboard.orgPage.title)
    }
  }
});